import React from 'react'
import { getSolverStatus, getSolverTacheStatus } from '../../common/solver/solverApi'
import { getCurrentCampagne } from '../../common/campagne/campagneSelector'
import { connect } from 'react-redux'
import { SOLVER_TASK_PERIOD } from '../gestionTache/services/gestionTache.consts'
import { LocalDateTime } from '../../../utils/date/local-date-time'

const solverStatusContextType = {
	/**
	 * @type {{
	 * status: string|null
	 * userGeneration: string|null
	 * dateLancementSolverCulture: string|null
	 * userSauvegarde: string|null
	 * dateApprobationSolutionCulture: string|null
	 * dateValidationTourDePlaine: string|null
	 * dateEnregistrementBesoinsDeProduction: string|null
	 * dateValidationPlanning: string|null
	 * dateFinSauvegarde: string|null
	 * fermeEnCours: string[]
	 * }|null}
	 */
	solverInfos: null,
	/**
	 * @type {{
	 * status: string|null
	 * userGeneration: string|null
	 * dateLancementSolverTache: string|null
	 * userSauvegarde: string|null
	 * dateApprobationSolutionTache: string|null
	 * dateFinSauvegarde: string|null
	 * dateDebutPlanification: string|null
	 * dateFinPlanification: string|null
	 * fermeEnCours: string[]
	 * }|null}
	 */
	solverTacheInfos: null,
	solverTachePeriod: SOLVER_TASK_PERIOD.WEEKS,
	/**
	 * @type {() => void}
	 */
	refreshSolverInfosForCurrentCampagne: () => {
	},
	/**
	 * @type {() => void}
	 */
	refreshSolverTacheInfos: () => {
	}
}

export const SolverStatusContext = React.createContext(solverStatusContextType)

export const useSolverStatusContext = () => React.useContext(SolverStatusContext)

const SolverStatusContextProvider = ({ children }) => {

	const [solverInfos, setSolverInfos] = React.useState(null)
	const [solverTacheInfos, setSolverTacheInfos] = React.useState(null)
	const [solverTachePeriod, setSolverTachePeriod] = React.useState(SOLVER_TASK_PERIOD.WEEKS)

	const refreshSolverInfosForCurrentCampagne = React.useCallback(
		() => getSolverStatus().then((response) => setSolverInfos(response)),
		[setSolverInfos]
	)

	React.useEffect(
		() => {
			refreshSolverInfosForCurrentCampagne()
		},
		[refreshSolverInfosForCurrentCampagne]
	)

	const refreshSolverTacheInfos = React.useCallback(
		() => getSolverTacheStatus().then((response) => {
			setSolverTacheInfos(response)

			if (response.dateDebutPlanification && response.dateFinPlanification) {
				const start = LocalDateTime.fromAPI(response.dateDebutPlanification)
				const end = LocalDateTime.fromAPI(response.dateFinPlanification)

				setSolverTachePeriod(end._diff(start, 'weeks') > 1 ? SOLVER_TASK_PERIOD.WEEKS : SOLVER_TASK_PERIOD.DAYS)
			}
		}),
		[setSolverTacheInfos]
	)

	React.useEffect(
		() => {
			refreshSolverTacheInfos()
		},
		[refreshSolverTacheInfos]
	)

	const contextValue = React.useMemo(
		() => ({ solverInfos, refreshSolverInfosForCurrentCampagne, solverTacheInfos, solverTachePeriod, refreshSolverTacheInfos }),
		[solverInfos, refreshSolverInfosForCurrentCampagne, solverTacheInfos, solverTachePeriod, refreshSolverTacheInfos]
	)

	return (
		<SolverStatusContext.Provider value={contextValue}>
			{children}
		</SolverStatusContext.Provider>
	)
}


const mapStateToProps = state => ({
	campagne: getCurrentCampagne(state)
})

export default connect(mapStateToProps)(SolverStatusContextProvider)
